import { motion } from 'framer-motion';
import { Star, Heart, Sparkles } from 'lucide-react';
import { NameMatch } from '../types';

interface MatchesListProps {
  matches: NameMatch[];
}

export default function MatchesList({ matches }: MatchesListProps) {
  const gradients = [
    'from-purple-100 to-pink-100',
    'from-blue-100 to-purple-100',
    'from-pink-100 to-rose-100',
    'from-indigo-100 to-blue-100'
  ];

  const icons = [
    <Star key="star" className="text-yellow-500" size={20} />,
    <Heart key="heart" className="text-red-500" size={20} />,
    <Sparkles key="sparkles" className="text-purple-500" size={20} />,
    <Star key="star-blue" className="text-blue-500" size={20} />
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
      {matches.map((match, index) => (
        <motion.div
          key={`${match.name}-${index}`}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className={`bg-gradient-to-br ${gradients[index % gradients.length]} backdrop-blur-sm rounded-lg p-6 shadow-sm transform hover:scale-105 transition-transform`}
        >
          <div className="flex items-center gap-2 mb-2">
            {icons[index % icons.length]}
            <h4 className="text-lg font-medium text-purple-900">
              {match.name}
            </h4>
          </div>
          <p className="text-purple-600 text-sm">{match.description}</p>
          <div className="mt-2 text-xs text-purple-500">
            Compatibility Score: {match.compatibility}%
          </div>
        </motion.div>
      ))}
    </div>
  );
}